/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * A user-facing capability that an entitlement can unlock. This is the granularity the
 * reducer answers access at ("does the user have access to feature X?"), one step removed from
 * the commercial ``GrantType``: a grant type is *what was bought/granted*, a feature is *what
 * that lets you do*. ``VisitType`` is the client-facing name for the visit features.
 */
export type Feature = (typeof Feature)[keyof typeof Feature];

export const Feature = {
  LIVE_CHAT_VISIT: "LIVE_CHAT_VISIT",
  VIDEO_VISIT: "VIDEO_VISIT",
  ASYNC_RX_VISIT: "ASYNC_RX_VISIT",
  ASYNC_DX_VISIT: "ASYNC_DX_VISIT",
  RX_RENEWAL_VISIT: "RX_RENEWAL_VISIT",
  FOLLOW_UP_VISIT: "FOLLOW_UP_VISIT",
} as const;
